import clsx from "clsx"
import classes from "./ButtonNext.module.scss"
import { NextIcon } from "../Icons"
import { useTranslate } from "@educaplay/core"
import { useDispatch, useSelector } from "react-redux";
import { incrementIndex } from "@educaplay/store/slices/gameSlice";
import { useEffect, useState } from "react";
import { isUnansweredAnswer } from "@educaplay/store/utils/functions";


export default function ButtonNext(props) {

    const { handleHover, passFinalQuestion ,type="submit", className } = props;

    const t = useTranslate();
    const dispatch = useDispatch();
    const currentIndex = useSelector(state => state.game.currentIndex);
    const question = useSelector(state => state.game.questions[state.game.currentIndex]);
    const questions = useSelector(state => state.game.questions)
    const isFinalQuestion = currentIndex === questions.length - 1;

    const navigationForwardHandler = () => {
        dispatch(incrementIndex());
    }

    const areUnansweredQuestions = (questions) => {
        return questions.some(question => isUnansweredAnswer(question.answer) )
    }

    useEffect(() => {
        if (!isFinalQuestion && !passFinalQuestion ) setActiveNextButton(!areUnansweredQuestions([question]))
    }, [currentIndex, isFinalQuestion, passFinalQuestion, question]
    )

    useEffect(() => {
        setActiveNextButton(false);
    }, [currentIndex])


    const [activeNextButton, setActiveNextButton] = useState(false);


    return (
        <button 
        type={type}
        className={clsx(classes.buttonPager, classes.buttonPager__next, activeNextButton && classes.active, className)} onClick={navigationForwardHandler} onMouseEnter={handleHover} >
            <span className={classes.buttonPager__icon}>
                <NextIcon/>
            </span>
            <div className={classes.buttonPager__text}>
                {t('specific.next')}
            </div>
        </button>
    )
}